import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73818e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "row p-4" }
const _hoisted_3 = { class: "col-md-4 customFilterRow" }
const _hoisted_4 = { class: "ag-background_grey w-100 text-center p-2" }
const _hoisted_5 = {
  class: "",
  style: {"padding":"8px 12px","background":"#edf0f1"}
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-md-4 customFilterRow" }
const _hoisted_8 = { class: "ag-background_grey w-100 text-center p-2" }
const _hoisted_9 = {
  class: "d-flex justify-content-center ag-background_boxgrey h-75 p-2",
  style: {"flex-direction":"column"}
}
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onUpdate:modelValue", "checked"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "col-md-4 customFilterRow" }
const _hoisted_16 = { class: "ag-background_grey w-100 text-center p-2" }
const _hoisted_17 = { class: "d-flex justify-content-between ag-background_boxgrey h-75 p-2" }
const _hoisted_18 = { class: "form-group form-check w-50" }
const _hoisted_19 = { class: "form-check-label" }
const _hoisted_20 = { class: "col-md-12 mt-4" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_loading = _resolveComponent("ag-loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ag-page_config position-relative",
    key: _ctx.compKey
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ag_loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ag_card, {
        module: _ctx.module.card1
      }, {
        "live-site-alerts": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("category")), 1),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("select", {
                  class: "custom-select",
                  size: "5",
                  id: "target",
                  style: {"min-height":"120px","padding":"0.5rem","border":"0px"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newAlertJson.selectedAlert) = $event)),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAlert($event)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: item.id
                    }, _toDisplayString(item.title), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newAlertJson.selectedAlert]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("conditions")), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentConditions, (item, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex align-items-center justify-content-center ag-background_boxgrey mb-3",
                    key: key
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.Label), 1),
                    (item.Field == 'SelectBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          class: "form-control form-control-sm",
                          style: {"width":"160px"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Options, (opt, optkey) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: optkey,
                              value: opt.value || opt
                            }, _toDisplayString(opt.label || opt), 9, _hoisted_12))
                          }), 128))
                        ], 8, _hoisted_11)), [
                          [_vModelSelect, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true),
                    (item.Field == 'CheckBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          checked: item.DefaultValue,
                          type: "checkbox"
                        }, null, 8, _hoisted_13)), [
                          [_vModelCheckbox, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true),
                    (item.Field == 'TextBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 2,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          type: "text",
                          maxlength: "191"
                        }, null, 8, _hoisted_14)), [
                          [_vModelText, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("action")), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("sendEmails")), 1)
                ]),
                (_openBlock(), _createBlock(_component_Multiselect, {
                  modelValue: _ctx.emails,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emails) = $event)),
                  mode: "tags",
                  "close-on-select": true,
                  searchable: true,
                  key: _ctx.compKey,
                  "create-tag": true,
                  "add-option-on": "'enter'|'space'|'tab'|';'|','",
                  "add-tag-on": "'enter'|'space'|'tab'|';'|','",
                  "append-new-tag": true,
                  "create-option": true,
                  onTag: _ctx.handleTagCreate,
                  "filter-results": false,
                  options: _ctx.emails
                }, null, 8, ["modelValue", "onTag", "options"]))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isEditing())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ag-button border-0 ag-button_primary ag-button_radius float-right pr-5 pl-5 ml-2",
                    disabled: _ctx.emails.length === 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addOrUpdateAlert(false)))
                  }, _toDisplayString(_ctx.$t("saveAlert")), 9, _hoisted_21))
                : _createCommentVNode("", true),
              (_ctx.currentConditions && !_ctx.isEditing())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "ag-button border-0 ag-button_primary ag-button_radius float-right pr-5 pl-5 ml-2",
                    disabled: _ctx.emails.length === 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addOrUpdateAlert()))
                  }, _toDisplayString(_ctx.$t("addAlert")), 9, _hoisted_22))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["module"]),
      _createVNode(_component_ag_card, {
        class: "custom-card",
        module: _ctx.module.liveSiteAlert
      }, null, 8, ["module"])
    ])
  ]))
}